module.exports = "//public.zight.com/packs/media/images/icons-embed-solid-48b93d3037c8d8eb787854177988151b.svg";